import { render, staticRenderFns } from "./ButtonRemove.vue?vue&type=template&id=6cd2ba4f&"
import script from "./ButtonRemove.vue?vue&type=script&lang=js&"
export * from "./ButtonRemove.vue?vue&type=script&lang=js&"
import style0 from "./ButtonRemove.vue?vue&type=style&index=0&id=6cd2ba4f&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports